var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$abilities.includes('update shipments'))?_c('v-btn',{attrs:{"color":"primary","small":"","disabled":!_vm.$route.query.batch || _vm.selectedOrders.length === 0},on:{"click":_vm.removeFromBatch}},[_vm._v(" Remove from batch "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(" mdi-delete ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }